import { DEX_TYPE } from "@/config/constants";
import { ReactComponent as SgTraDexLogo } from '@/assets/svgs/SGTraDex-logo-new.svg'
import {ReactComponent as SGTradexLandingPageLogo} from '@/assets/svgs/logo-sgtradex.svg'
import { ReactComponent as BuilDexLogo } from '@/assets/svgs/BuilDex-logo-new.svg'
import { ReactComponent as BuildexLandingPageLogo } from '@/assets/svgs/buildex-landing-logo.svg'
import { ReactComponent as SgTraDexCircularHero } from '@/assets/svgs/hero-circular-shape-tradex.svg'
import { ReactComponent as BuilDexCircularHero } from '@/assets/svgs/hero-circular-shape-buildex.svg'
// import { ReactComponent as HealthDexLogo } from '@/assets/svgs/HealthDex-logo-new.svg'
// import { ReactComponent as HealthdexLandingPageLogo } from '@/assets/svgs/healthdex-landing-logo.svg'
// import { ReactComponent as HealthDexCircularHero } from '@/assets/svgs/hero-circular-shape-healthdex.svg'

export const DEX_CONFIG = {
	[DEX_TYPE.SGTRADEX]: {
		dexName: "SGTraDex",
		tagline: "Making your trade data sharing easy and secure",
		backgroundImage: "Sgtradex-full__BG.png",
		LandingLogo: SgTraDexLogo,
		LogoComponent:SGTradexLandingPageLogo,
		HeroCircle: SgTraDexCircularHero,
		SignupSuccessImage: 'sign-up-success.png',
		SignUpSuccessTitle: "Account created successfully.",
		SignUpSuccessContent: "Please check your email for a link to set your password and access the rest of SGTraDex content."

	},
	[DEX_TYPE.SGBUILDEX]: {
		dexName: "SGBuildex",
		tagline: "Making your building and construction data sharing easy and secure",
		backgroundImage: "Buildex-full__BG.png",
		LogoComponent: BuilDexLogo,
		LandingLogo:BuildexLandingPageLogo,
		HeroCircle: BuilDexCircularHero,
		SignupSuccessImage: 'sign-up-buildex-success.png',
		SignUpSuccessTitle: "Company account requested!",
		SignUpSuccessContent: 'The request has been sent to our System Admin. It will be provisioned shortly. Please check your email for a link to set your password and access the rest of SGBuildex content.'
	},
	[DEX_TYPE.SGHEALTHDEX]: {
		dexName: "SGHealthdex",
		tagline: "Making your healthcare data sharing easy and secure",
		backgroundImage: "Healthdex-full__BG.png",
		//LogoComponent: HealthDexLogo,
		//LandingLogo:HealthdexLandingPageLogo,
		//HeroCircle: HealthDexCircularHero,
		SignupSuccessImage: 'sign-up-healthdex-success.png',
		SignUpSuccessTitle: "Company account requested!",
		SignUpSuccessContent: 'The request has been sent to our System Admin. It will be provisioned shortly. Please check your email for a link to set your password and access the rest of HealthDex content.'
	}
};

function getDexConfig(dexType) {
	const defaultConfig = DEX_CONFIG[DEX_TYPE.SGTRADEX];
	const currentConfig = DEX_CONFIG[dexType] || {};

	return {
		backgroundImage: currentConfig.backgroundImage ?? defaultConfig.backgroundImage,
		LogoComponent: currentConfig.LogoComponent ?? defaultConfig.LogoComponent,
		LandingLogo: currentConfig.LandingLogo ?? defaultConfig.LandingLogo,
		dexName: currentConfig.dexName ?? defaultConfig.dexName,
		tagline: currentConfig.tagline ?? defaultConfig.tagline,
		HeroCircle: currentConfig.HeroCircle ?? null,
		SignupSuccessImage: currentConfig.SignupSuccessImage ?? defaultConfig.SignupSuccessImage,
		SignUpSuccessTitle: currentConfig.SignUpSuccessTitle ?? defaultConfig.SignUpSuccessTitle,
		SignUpSuccessContent: currentConfig.SignUpSuccessContent ?? defaultConfig.SignUpSuccessContent
	};
}

export { getDexConfig };
